import _ from 'lodash';
function convertPropertiesToArray(properties) {
    return _.map(properties, (type, key) => ({
        type,
        key,
        isNew: false,
    }));
}
export default convertPropertiesToArray;
